import { apiService } from './apiService';

export type CorporateCarrier = {
  id: string;
  fullName: string;
  username: string;
  email: string;
  phone: string;
  companyTitle: string;
  taxOffice: string;
  taxNumber: string;
  city: string;
  district: string;
  address: string;
  authorizedPersonName: string;
  authorizedPersonPhone: string;
  authorizedPersonEmail: string;
  status: 'active' | 'inactive' | 'suspended';
  subUserCount: number;
  driverCount: number;
  vehicleCount: number;
  trailerCount: number;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type CorporateCarrierPayload = Partial<CorporateCarrier> & { password?: string };

export type CorporateCarrierSubUser = {
  id: string;
  fullName: string;
  username: string;
  email: string;
  phone: string;
  status: 'active' | 'inactive' | 'suspended';
};

export type CorporateCarrierSubUserPayload = Partial<CorporateCarrierSubUser> & { password?: string };

export type CorporateCarrierDriver = {
  id: string;
  fullName: string;
  phone: string;
  email: string;
  tcNumber: string;
  city: string;
  district: string;
  cekiciPlaka: string;
  dorsePlaka: string;
  vehicleType: string;
  licenseNumber: string;
  licenseClass: string;
  experienceYears: number;
  status: string;
  createdAt?: string | null;
};

export const corporateCarrierService = {
  async getAll(params?: { search?: string; status?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.status) queryParams.append('status', params.status);
    const query = queryParams.toString();
    return apiService.get<CorporateCarrier[]>(`/corporate-carriers${query ? `?${query}` : ''}`);
  },

  async getById(id: string | number) {
    return apiService.get<CorporateCarrier>(`/corporate-carriers/${id}`);
  },

  async create(payload: CorporateCarrierPayload) {
    return apiService.post('/corporate-carriers', payload);
  },

  async update(id: string | number, payload: CorporateCarrierPayload) {
    return apiService.put(`/corporate-carriers/${id}`, payload);
  },

  async delete(id: string | number) {
    return apiService.delete(`/corporate-carriers/${id}`);
  },

  async getSubUsers(id: string | number) {
    return apiService.get<CorporateCarrierSubUser[]>(`/corporate-carriers/${id}/sub-users`);
  },

  async getDrivers(id: string | number) {
    return apiService.get<CorporateCarrierDriver[]>(`/corporate-carriers/${id}/drivers`);
  },

  async createSubUser(id: string | number, payload: CorporateCarrierSubUserPayload) {
    return apiService.post(`/corporate-carriers/${id}/sub-users`, payload);
  },

  async updateSubUser(id: string | number, subUserId: string | number, payload: CorporateCarrierSubUserPayload) {
    return apiService.put(`/corporate-carriers/${id}/sub-users/${subUserId}`, payload);
  },

  async deleteSubUser(id: string | number, subUserId: string | number) {
    return apiService.delete(`/corporate-carriers/${id}/sub-users/${subUserId}`);
  },
};
